module.exports = __webpack_public_path__ + "static/media/student.7990f0f8.jpg";